export default "__VITE_ASSET__e5b275e0__"